var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeatNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 19,
    viewBox: "0 0 25 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7805 7.45596H21.7425C23.3341 7.45596 24.6287 8.75061 24.6287 10.3421V15.9702C24.6287 17.5617 23.3341 18.8564 21.7425 18.8564H13.2764H11.3523H2.88618C1.29465 18.8564 0 17.5617 0 15.9702V10.3421C0 8.75061 1.29465 7.45596 2.88618 7.45596H3.84824V3.84824C3.84824 1.72626 5.5745 0 7.69648 0H16.9323C19.0542 0 20.7805 1.72626 20.7805 3.84824V7.45596ZM5.77236 16.9323H18.8564V15.874C18.8564 15.3435 18.4248 14.9119 17.8943 14.9119H6.73442C6.20397 14.9119 5.77236 15.3435 5.77236 15.874V16.9323ZM16.9323 1.92412H7.69648C6.63558 1.92412 5.77236 2.78734 5.77236 3.84824V13.1533C6.07357 13.0464 6.39713 12.9878 6.73442 12.9878H17.8943C18.2316 12.9878 18.5552 13.0464 18.8564 13.1533V3.84824C18.8564 2.78734 17.9931 1.92412 16.9323 1.92412ZM1.92412 10.3421V15.9702C1.92412 16.5006 2.35573 16.9323 2.88618 16.9323H3.84824V9.38008H2.88618C2.35573 9.38008 1.92412 9.81169 1.92412 10.3421ZM21.7425 16.9323C22.273 16.9323 22.7046 16.5006 22.7046 15.9702V10.3421C22.7046 9.81169 22.273 9.38008 21.7425 9.38008H20.7805V16.9323H21.7425Z",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatNew);
export default __webpack_public_path__ + "static/media/seat_new.46d0c852.svg";
export { ForwardRef as ReactComponent };